const routes = [
  { 
    name: 'index',
    path: '/',
    component: () => import(/* webpackChunkName: "Home" */ '@/components/pages/Home/'),
  },
  { 
    name: 'br',
    path: '/br',
    redirect: { name: 'index' },
  },
  { 
    name: 'pt',
    path: '/pt',
    redirect: { name: 'index' },
  },
  {
    name: 'home',
    path: '/home',
    redirect: { name: 'index' }
  },
  {
    name: 'plans',
    path: '/plans',
    component: () => import(/* webpackChunkName: "Plans" */ '@/components/pages/Plans/'),
  },
  {
    name: 'contact',
    path: '/contact',
    component: () => import(/* webpackChunkName: "Contanct" */ '@/components/pages/Contact/'),
  },
  {
    name: 'create_account',
    path: '/create_account',
    component: () => import(/* webpackChunkName: "Create Account" */ '@/components/pages/CreateAccount/'),
  },
  // {
  //   path: '/chennel_list',
  //   component: () => import(/* webpackChunkName: "ChannelList" */ '@/components/Channels/ChennelList'),
  // },
  // {
  //   path: '/channel_form',
  //   component: () => import(/* webpackChunkName: "ChannelForm" */ '@/components/Channels/ChannelForm'),
  // },

  { 
    name: 'features',
    path: '/features',
    component: () => import(/* webpackChunkName: "Features" */ '@/components/pages/Features/'),
  },
  { 
    name: 'features_pt',
    path: '/features/pt',
    redirect: { name: 'features' }
  },
  { 
    name: 'features_br',
    path: '/features/br',
    redirect: { name: 'features' }
  },
  { 
    name: 'tasks',
    path: '/tasks',
    component: () => import(/* webpackChunkName: "Tasks" */ '@/components/pages/Features/Tasks'),
  },
  { 
    name: 'tasks_br',
    path: '/tasks/br',
    redirect: { name: 'tasks' }
  },
  { 
    name: 'tasks_pt',
    path: '/tasks/pt',
    redirect: { name: 'tasks' }
  },
  // {
  //   name: 'features/financial',
  //   path: '/financial',
  //   component: () => import(/* webpackChunkName: "Financial" */ '@/components/pages/Features/Financial'),
  // },
  // {
  //   name: 'features/process',
  //   path: '/process',
  //   component: () => import(/* webpackChunkName: "Process" */ '@/components/pages/Features/Process'),
  // },
  // {
  //   name: 'features/profile_bank',
  //   path: '/profile_bank',
  //   component: () => import(/* webpackChunkName: "ProfileBank" */ '@/components/pages/Features/ProfileBank'),
  // },

  // Recruitment
  {
    name: 'features/recruitment',
    path: '/recruitment',
    component: () => import(/* webpackChunkName: "Recruitment" */ '@/components/pages/Features/Recruitment'),
  },
  {
    name: 'features/recruitment_br',
    path: '/recruitment/br',
    component: () => import(/* webpackChunkName: "Recruitment" */ '@/components/pages/Features/Recruitment'),
  },
  {
    name: 'features/recruitment_pt',
    path: '/recruitment/pt',
    component: () => import(/* webpackChunkName: "Recruitment" */ '@/components/pages/Features/Recruitment'),
  },

  // Quotation
  {
    name: 'quotation',
    path: '/quotation',
    component: () => import(/* webpackChunkName: "Quotation" */ '@/components/pages/Features/Quotation'),
  },
  {
    name: 'quotation_br',
    path: '/quotation/br',
    component: () => import(/* webpackChunkName: "Quotation" */ '@/components/pages/Features/Quotation'),
  },
  {
    name: 'quotation_pt',
    path: '/quotation/pt',
    component: () => import(/* webpackChunkName: "Quotation" */ '@/components/pages/Features/Quotation'),
  },

  // Resumes
  {
    name: 'resumes',
    path: '/resumes',
    component: () => import(/* webpackChunkName: "Resumes" */ '@/components/pages/Features/Resumes'),
  },
  {
    name: 'resumes_br',
    path: '/resumes/br',
    component: () => import(/* webpackChunkName: "Resumes" */ '@/components/pages/Features/Resumes'),
  },
  {
    name: 'resumes_pt',
    path: '/resumes/pt',
    component: () => import(/* webpackChunkName: "Resumes" */ '@/components/pages/Features/Resumes'),
  },

  // Candidate
  {
    name: 'candidate',
    path: '/candidate',
    component: () => import(/* webpackChunkName: "Candidate" */ '@/components/pages/Features/Candidate'),
  },
  {
    name: 'candidate_br',
    path: '/candidate/br',
    component: () => import(/* webpackChunkName: "Candidate" */ '@/components/pages/Features/Candidate'),
  },
  {
    name: 'candidate_pt',
    path: '/candidate/pt',
    component: () => import(/* webpackChunkName: "Candidate" */ '@/components/pages/Features/Candidate'),
  },

  {
    name: 'features/sales_and_purchasing',
    path: '/sales_and_purchasing',
    component: { redirect: { name: 'features' } }
  },
  { 
    name: 'features/projects',
    path: '/features',
    component: { redirect: { name: 'features' } }
  },
]

export default routes;